export default __webpack_public_path__ + "18d073b346f6ec5a5aad0ff49392d46f.png";